


import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {AnimatedWinLinesView} from "./AnimatedWinLinesView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TractorBeamParsedInitData} from "../../server/data/TractorBeamParsedInitData";
import Timeline = gsap.Timeline;
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TractorBeamParsedGameData} from "../../server/data/TractorBeamParsedGameData";

export class AnimatedWinLinesController extends BaseController {

    private _view:AnimatedWinLinesView;
    private _winLineTl:Timeline | null;

    constructor() {
        super();

        this._view = new AnimatedWinLinesView();
        this.addEventListeners();

    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));

        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:SpinEvent) => {
            //console.log("spin start");
            if(this._winLineTl) {
                //console.log("spin start:" + this._winLineTl);
                this._winLineTl.pause();
                this._winLineTl.kill();
                this._winLineTl = null;
            }
            this._view.abort();
        });
    }

    public onGameDataParsed(data:TractorBeamParsedGameData):void {
        this._winLineTl = null;
        this._view.reset();
        this._view.setCurrentBetWins(data.betWins!.length | 0);
    }

    public onInitDataParsed(data:TractorBeamParsedInitData):void {
        this._view.betLinesData = data.betLines;
        /*console.log("\n \n \n \n \n \n ");
        console.log("------------------------------------------ BET LINES DATA ---------------------------------------------");
        console.log(data.betLines);
        console.log("\n \n \n \n \n \n ");*/
    }

    public playAnimatedWinline(winLine:number):void {
        const winTl:Timeline = this._view.getWinlineTL(winLine);
        winTl.play();
        this._winLineTl = winTl;
    }

    protected onSpinStart():void {

    }

}
